/**
 * @generated SignedSource<<900bb26ad796546065afdbf1e262ec5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProfileAvailabilityEnum = "available_now" | "available_soon" | "not_available";
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type BadgesArea_User$data = {
  readonly backgroundCheckCompleted: boolean | null | undefined;
  readonly profile: {
    readonly availability: ProfileAvailabilityEnum | null | undefined;
    readonly canWorkInTheUs: boolean | null | undefined;
    readonly managedTeamSize: string | null | undefined;
  } | null | undefined;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AvailabilityAndPositionTypeFields_User" | "StatusField_User" | "TeamManagementField_User" | "USWorkField_User">;
  readonly " $fragmentType": "BadgesArea_User";
};
export type BadgesArea_User$key = {
  readonly " $data"?: BadgesArea_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"BadgesArea_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BadgesArea_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundCheckCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availability",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canWorkInTheUs",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "managedTeamSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvailabilityAndPositionTypeFields_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StatusField_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamManagementField_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "USWorkField_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2fbce5c881776a01bff45c7ad41f92bd";

export default node;
